@if (categories) {
    <sirius-grid class="heading-wrapper">
        @if (selectedCategory) {
            <h3 class="title sir-text-style-title-m-default" data-cy="slider-heading-with-selected-category">
                {{ 'page.categoryWithName' | translate: { categoryName: selectedCategory } }}
            </h3>
        } @else {
            <h3 class="title sir-text-style-title-m-default" data-cy="slider-heading">{{ 'page.categories' | translate }}</h3>
        }
    </sirius-grid>
}

<sirius-card-slider [items]="categories" data-cy="marketplace-categories"></sirius-card-slider>
